import { createEndpoint } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import { PredictiveSearchResponse, PredictiveSearchResponseSchema } from "../schemas/predictive-search";

export interface PredictiveSearchQueryParams extends QueryParams {
    /** Search query (max 255 characters) */
    query: string;
    /** Maximum items per group (1-20, default: 4) */
    limit?: number;
}

export function createPredictiveSearchApi(http: HttpClient, baseUrl: string) {
    return {
        search: createEndpoint<PredictiveSearchResponse, unknown, PredictiveSearchQueryParams>(
            http,
            'GET',
            '/search/predictive',
            {
                base: baseUrl,
                responseSchema: PredictiveSearchResponseSchema,
            }
        ),
    }
}

